var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('div', {
    class: _vm.$style.breadcrumbs
  }, [_c('div', [_c('BaseLink', {
    staticClass: "p2",
    class: _vm.$style.breadcrumbLink,
    attrs: {
      "to": {
        name: 'resources'
      }
    }
  }, [_c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.backButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "gray"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  })], 1)], 1), _c('div', [_c('BaseLink', {
    staticClass: "p2",
    class: _vm.$style.breadcrumbLink,
    attrs: {
      "to": {
        name: 'resources'
      }
    }
  }, [_vm._v("RESOURCES")]), _vm.resource.categoryName ? _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "data-breadcrumb-separator": "",
      "name": "chevron-right"
    }
  }) : _vm._e(), _vm.resource.categoryName ? _c('BaseLink', {
    staticClass: "p2",
    class: _vm.$style.breadcrumbLink,
    attrs: {
      "to": {
        name: 'resources',
        params: {
          category: _vm.resource.categoryName.toLowerCase()
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.resource.categoryName.toUpperCase()) + " ")]) : _vm._e(), _vm.resource.subcategoryName ? _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "data-breadcrumb-separator": "",
      "name": "chevron-right"
    }
  }) : _vm._e(), _vm.resource.subcategoryName ? _c('BaseLink', {
    staticClass: "p2",
    class: _vm.$style.breadcrumbLink,
    attrs: {
      "to": {
        name: 'resources',
        params: {
          category: _vm.resource.categoryName.toLowerCase(),
          subcategory: _vm.resource.subcategoryName.toLowerCase()
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.resource.subcategoryName.toUpperCase()) + " ")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex",
    class: _vm.$style.resourceTitleSection
  }, [_c('h2', {
    staticClass: "color-primary-blue",
    class: _vm.$style.resourceTitle
  }, [_vm._v(_vm._s(_vm.resource.title))]), _vm.loadingFavorite ? _c('LoaderIcon', {
    staticClass: "d-inline",
    class: _vm.$style.heartIcon
  }) : _vm.resource.resourceId ? _c('FavoriteHeart', {
    class: _vm.$style.heartIcon,
    attrs: {
      "is-favorite": _vm.resource.isFavorite
    },
    on: {
      "handleHeartClick": _vm.handleHeartClick
    }
  }) : _vm._e(), _vm.resource.resourceId ? _c('CopyToClipboardButton', {
    class: _vm.$style.clipboardButton,
    attrs: {
      "text-to-copy": _vm.resourceUrl
    }
  }) : _vm._e()], 1), _c('p', {
    staticClass: "p1 color-dark-gray"
  }, [_vm._v(_vm._s(_vm.resource.revisedAt))]), _c('p', {
    staticClass: "p1 color-primary-charcoal",
    class: _vm.$style.resourceTextContent,
    domProps: {
      "innerHTML": _vm._s(_vm.resource.content)
    }
  }), _vm.resource.tags && _vm.resource.tags.length ? _c('div', {
    staticClass: "tagsContainer",
    class: _vm.$style.resourceTags
  }, _vm._l(_vm.resource.tags, function (tag) {
    return _c('span', {
      key: tag,
      staticClass: "tag-text"
    }, [_vm._v(_vm._s(tag))]);
  }), 0) : _vm._e(), _vm.youtubeVideoId ? _c('youtube', {
    class: _vm.$style.frameVideo,
    attrs: {
      "video-id": _vm.youtubeVideoId,
      "player-width": "864",
      "player-height": "486"
    }
  }) : _vm._e(), _vm.vimeoVideoId ? _c('vimeo-player', {
    class: _vm.$style.frameVideo,
    attrs: {
      "video-id": _vm.vimeoVideoId,
      "player-width": "864",
      "player-height": "486"
    }
  }) : _vm._e(), _vm.resource.isDownloadable ? _c('ResourceDownloadFile', {
    attrs: {
      "resource": _vm.resource
    }
  }) : _vm._e(), _vm.getAllRelatedResources.length ? _c('div', [_c('hr', {
    class: _vm.$style.hr
  }), _c('div', {
    class: _vm.$style.gridView
  }, _vm._l(_vm.getAllRelatedResources, function (relatedResource) {
    return _c('ResourceBlock', {
      key: relatedResource.resourceId,
      class: _vm.$style.resourceBlock,
      attrs: {
        "resource": relatedResource
      }
    });
  }), 1)]) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "view-resource-modal",
      "modal-class": ['right', 'modal-resource'],
      "hide-footer": "",
      "hide-header": "",
      "title": "BootstrapVue"
    }
  }, [_c('ModalResource', {
    attrs: {
      "toast-component": this.$bvToast
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }